import { render, staticRenderFns } from "./ZztTixianModal.vue?vue&type=template&id=1392d4ed&"
import script from "./ZztTixianModal.vue?vue&type=script&lang=js&"
export * from "./ZztTixianModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports